import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { BASE_URL } from '../../utils/axios';
import { buildUrlParams } from '../../utils/urls';
import { parsePaginatedResponse } from '../../utils/pagination';

export const brandsApi = createApi({
  reducerPath: 'brandsApi',
  tagTypes: ['Brands'],
  keepUnusedDataFor: 600,
  endpoints: (builder) => ({
    getBrands: builder.query({
      async queryFn(arg = {}) {
        try {
          const url = `/api/v1/brands/${buildUrlParams(arg)}`;
          const { data } = await axios.get(BASE_URL + url);
          return { data: parsePaginatedResponse({ data }) };
        } catch (e) {
          return {
            error: {
              status: e.response?.status,
              data: e.response?.data ?? e.message,
            },
          };
        }
      },
      providesTags: [{ type: 'Brands', id: 'LIST' }],
    }),
    deleteBrand: builder.mutation({
      async queryFn({ hash }) {
        try {
          await axios.delete(`${BASE_URL}/api/v1/brands/${hash}/`);
          return { data: { hash } };
        } catch (e) {
          return {
            error: {
              status: e.response?.status,
              data: e.response?.data ?? e.message,
            },
          };
        }
      },
      invalidatesTags: [{ type: 'Brands', id: 'LIST' }],
    }),
  }),
});

export const { useGetBrandsQuery, useDeleteBrandMutation } = brandsApi;
